import React, { useEffect, useState, useRef } from "react";
import Backicon from "../../assets/icon/leftIcon.png";
import { Link } from "react-router-dom";
import { getCategory } from "../../state/categoryState";
import { getProduct } from "../../state/productState";
import { getRestaurant } from "../../state/restaurantState";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./styles.css";
import Footer from "../../components/Footer";
import ProductModal from "../../components/ProductModal";
import useGetImages from "../../components/useGetImages";
import menuIcon from "../../assets/icon/menuIcon.png";
import empty from '../../assets/images/empty.jpg';
const MenuCategory = ({
  category,
  id,
  chooseCategory,
  filterProducts,
  visible,
}) => {
  const { image: uri } = useGetImages(
    "category_pictures",
    id,
    category.CATEGORY
  );

  return (
    <div
      className={
        chooseCategory === category.CATEGORY
          ? "choose_categpry_card"
          : "category_card"
      }
      onClick={() => filterProducts(category.CATEGORY)}
    >
      {!visible && (
        <div className="md:mr-4">
          {/* {uri && (
            <img
              src={uri}
              alt="category"
              className="w-10 h-10 rounded-full overflow-hidden"
            />
          )}
        </div>
      )} */}
           {uri ? (
            <img
              src={uri}
              alt="category"
              className="w-10 h-10 rounded-full overflow-hidden"
            />
          ):(
            <img
            src={empty}
            alt="category"
            className="w-10 h-10 rounded-full overflow-hidden"
          />

          )}
        </div>
      )}
      <p
        className="font-bold text-[8px] m-2 text-center text-stone-900"
        onClick={() => filterProducts(category.CATEGORY)}
      >
        {category.CATEGORY}
      </p>
    </div>
  );
};

const ProductCard = ({ product, id, setCartModal, setProductDetail }) => {
  const { image: uri } = useGetImages(
    "product_pictures",
    id,
    product?.URUN_KOD
  );

  if (!product) return null;

  const handleOpenModal = () => {
    setCartModal(true);
    setProductDetail(product);
  };


  return (
    <div className="product_card" onClick={handleOpenModal}>
      {/* {uri && (
        <img
          src={uri}
          alt="product"
          className="w-24 h-24 object-center rounded-full shadow-md"
        />
      )} */}
          {uri ? (
        <img
          src={uri}
          alt="product"
          className="w-24 h-24 object-center rounded-full shadow-md"
        />
      ):(
        <img
        src={empty}
        alt="product"
        className="w-24 h-24 object-center rounded-full shadow-md"
      />

      )}

      <div className="product_content">
        <p className="product_name">{product?.URUN_ADI}</p>
        {product?.URUN_ACIKLAMA && (
          <p className="product_desc">
            {product?.URUN_ACIKLAMA?.split(",")
              .map((item) => item.trim())
              .join(", ") + ". "}
          </p>
        )}
        {product?.FIYATI && (
          <p className="product_price">{product?.FIYATI} ₺</p>
        )}
      </div>
    </div>
  );
};

const Menu = ({ id }) => {
  const categories = useSelector((state) => state.categories.category);
  const products = useSelector((state) => state.products.product);
  const restaurants = useSelector((state) => state.restaurants.restaurant);
  const swiperRef = useRef(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const firstCategory = new URLSearchParams(location.search).get("category");
  const [chooseCategory, setChooseCategory] = useState(firstCategory);
  const [visible, setVisible] = useState(false);
  const [cartModal, setCartModal] = useState(false);
  const [productDetail, setProductDetail] = useState();

  useEffect(() => {
    const data1 = { path: id + "/categoryno.json" };
    const data2 = { path: id + "/productsno.json" };
    const data3 = { path: id + "/restaurant.json" };

    dispatch(getProduct(data2));
    dispatch(getCategory(data1));
    dispatch(getRestaurant(data3));
  }, [dispatch, id]);

  const [productItems, setProductItems] = useState(products);

  useEffect(() => {
    if (firstCategory !== undefined) {
      const categoryIndex = categories.findIndex(
        (num) => num.CATEGORY === firstCategory
      );
      window.scrollTo(0, 0);
      swiperRef?.current?.swiper?.slideTo(categoryIndex);
      return setProductItems(
        products?.filter?.((product) => product.CATEGORY === firstCategory)
      );
    }
  }, [firstCategory, products, categories]);

  const filterProducts = (categories) => {
    const urunler = products?.filter?.((product) => {
      return product.CATEGORY === categories;
    });
    setProductItems(urunler);
    setChooseCategory(categories);
    window.scrollTo(0, 0);
  };

  //headeri üstte sabitlemek için
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        setVisible(true); //header üstte fixlenir
      } else {
        setVisible(false);
      }
    });
  }, []);

  return (
    <div className="min-h-screen">
      <div
        className={
          visible
            ? "fixed top-0 left-0 right-0 z-5 bg-white shadow-md py-2"
            : ""
        }
      >
        <Link to="/category" className="flex items-center my-2 px-4">
          <img src={Backicon} alt="back" className="w-8 h-8" />
        </Link>

        <div className="px-4 flex justify-between items-center">
          <h3 className="text-xl font-bold ">Menu</h3>
          <img src={menuIcon} alt="menuimg" className="w-8 h-8 mr-2" />
        </div>

        <div className="mt-2 px-4">
          <Swiper
            ref={swiperRef}
            slidesPerView={2}
            spaceBetween={10}
            pagination={false}
            modules={[Pagination]}
            className="mySwiper"
          >
            {categories?.map((item, index) => (
              <SwiperSlide>
                <MenuCategory
                  filterProducts={filterProducts}
                  category={item}
                  key={index}
                  id={id}
                  chooseCategory={chooseCategory}
                  visible={visible}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <div className="container-max px-4">
        {productItems ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-8 mt-5">
            {productItems.map((item, index) => (
              <ProductCard
                product={item}
                key={index}
                id={id}
                setCartModal={setCartModal}
                setProductDetail={setProductDetail}
              />
            ))}
          </div>
        ) : (
          <div className="flex flex-col justify-center items-center mt-10">
            <p>Yükleniyor...</p>
          </div>
        )}
      </div>
      {!!restaurants?.length && <Footer res={restaurants?.[0]} />}
      {cartModal && (
        <ProductModal
          setCartModal={setCartModal}
          productDetail={productDetail}
          id={id}
        />
      )}
    </div>
  );
};

export default Menu;
